<template>
	<div class="inbox">
		<bsf-page-header>
			<h3 slot="header">Forms 组件</h3>
		</bsf-page-header>
		<breadcrumb :data="$store.state.bcArray"></breadcrumb>
	</div>
</template>
<script>
	import bsfPageHeader from 'components/comp/pageheader'
	import breadcrumb from 'components/comp/breadcrumbs'
	export default {
		components: {
			bsfPageHeader,
			breadcrumb
		},
		data() {
			return {
				navdata1: [{
					name: "Home",
					href: ""
				}, {
					name: "Profile",
					href: ""
				}, {
					name: "Message",
					href: "",
					active: true
				}],
			}
		}
	}
</script>
<style lang="less">
	@import (reference) "../assets/lib/css.less";
</style>


// WEBPACK FOOTER //
// forms.vue?55183bea